export const providersOption = [
    { value: 0, name: 'Microsoft' },
    // { value: 1, name: 'Google' },
    // { value: 2, name: 'Facebook' },
];
